<script setup lang="ts">
import SelectButton from '@/components/forms/SelectButton.vue';
import FormsFieldError from '@/components/forms/FieldError.vue';
const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:model-value']);

const eventTypes = ref({});
onBeforeMount(async () => {
  eventTypes.value = await $fetch('/api/event-types');
  console.log('eventTypes.value', eventTypes.value);
});

const formValue = ref(props.modelValue);

function onTypeSelected(value: string) {
  formValue.value = value;
  emit('update:model-value', formValue.value);
}

const validationError = ref(false);

function validate(): boolean {
  if (formValue.value === '') {
    validationError.value = true;
    return false;
  }

  emit('update:model-value', formValue.value);
  return true;
}

defineExpose({validate});
</script>

<template>
  <div style="height: 100%">
    <h3>Type of Event</h3>

    <ul>
      <li v-for="value in eventTypes" :key="value + 1">
        <SelectButton :class="{'!bg-[var(--ever-color)] !border-[var(--ever-color)] !text-white': formValue === value}" :disabled @click="onTypeSelected(value)">{{ value }}</SelectButton>
      </li>
    </ul>

    <FormsFieldError v-if="formValue === '' && validationError" style="text-align: center">Please select type of event</FormsFieldError>
  </div>
</template>
